import React, { useEffect, useState } from 'react'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, SubmitHandler } from 'react-hook-form'
import { errorToast, successToast } from 'src/utils/toastService'
import { useUpdateParentGymMutation, useGetParentGymByIdQuery } from 'src/api/parentGymApi'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'

type IFormInput = {
  name: string
}

const formSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
})

type useEditParentGymProps = {
  successCallback: () => void
  id: number
}
const useEditParentGym = ({ successCallback, id }: useEditParentGymProps) => {
  const [file, setFile] = useState<File | null>(null)
  const [imageUrl, setImageUrl] = useState<string>('')
  const [showUploadImage, setShowUploadImage] = useState(false)
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'all',
    defaultValues: {
      name: '',
    },
  })
  const { data, isFetching, refetch } = useGetParentGymByIdQuery(id)

  const [updateParentGym, { isLoading: isLoadingEditParentGym }] = useUpdateParentGymMutation()
  const dispatch = useDispatch<AppDispatch>()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setFile(e.target.files[0])
    }
  }

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    console.log(data, file)

    const formData = new FormData()
    formData.append('name', data.name)
    if (file) {
      formData.append('picture', file)
    }
    updateParentGym({
      id,
      data: formData,
    })
      .unwrap()
      .then((res) => {
        console.log(res)
        successToast('Gym updated successfully.')
        reset()
        setFile(null)
        successCallback()
      })
      .catch((err) => {
        console.log(err)
        errorToast('Unable to updated Gym.')
      })
  }
  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  useEffect(() => {
    if (data) {
      setValue('name', data.name)
      if (data.picture) {
        setImageUrl(data.picture)
      }
    }
  }, [data])

  return {
    file,
    handleFileChange,
    onSubmit: handleSubmit(onSubmit),
    control,
    errors,
    isLoadingEditParentGym,
    imageUrl,
    showUploadImage,
    handleShowUploadImage: () => setShowUploadImage(true),
  }
}

export default useEditParentGym
